var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGaming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Offer Icon / gaming") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A41B32",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E0C1D",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Offer-Icon-/-gaming",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70089111,18.6611206 L16.2611206,12.1012573 C16.9796265,11.3823853 16.9796265,10.2172485 16.2611206,9.49874268 L9.70125732,2.93887939 C8.98275146,2.22037354 7.81761475,2.22037354 7.09910889,2.93887939 L0.538879395,9.49874268 C-0.179626465,10.2172485 -0.179626465,11.3823853 0.538879395,12.1008911 L7.09874268,18.6611206 C7.81724854,19.3796265 8.98238525,19.3796265 9.70089111,18.6611206 Z M8.4,6.9 C7.903125,6.9 7.5,6.496875 7.5,6 C7.5,5.50275879 7.903125,5.1 8.4,5.1 C8.896875,5.1 9.3,5.50275879 9.3,6 C9.3,6.496875 8.896875,6.9 8.4,6.9 Z M22.2,21.6 C23.1941162,21.6 24,20.7941162 24,19.8 L24,11.4 C24,10.4058838 23.1941162,9.6 22.2,9.6 L17.7472412,9.6 C18.2231323,10.7096191 18.0142456,12.0450073 17.1097412,12.9495117 L12,18.0592529 L12,19.8 C12,20.7941162 12.8058838,21.6 13.8,21.6 L22.2,21.6 Z M3.6,11.7 C3.103125,11.7 2.7,11.296875 2.7,10.8 C2.7,10.3027588 3.103125,9.9 3.6,9.9 C4.096875,9.9 4.5,10.3027588 4.5,10.8 C4.5,11.296875 4.096875,11.7 3.6,11.7 Z M13.2,11.7 C12.703125,11.7 12.3,11.296875 12.3,10.8 C12.3,10.3027588 12.703125,9.9 13.2,9.9 C13.696875,9.9 14.1,10.3027588 14.1,10.8 C14.1,11.296875 13.696875,11.7 13.2,11.7 Z M18,16.5 C17.503125,16.5 17.1,16.096875 17.1,15.6 C17.1,15.1027588 17.503125,14.7 18,14.7 C18.496875,14.7 18.9,15.1027588 18.9,15.6 C18.9,16.096875 18.496875,16.5 18,16.5 Z M8.4,16.5 C7.903125,16.5 7.5,16.096875 7.5,15.6 C7.5,15.1027588 7.903125,14.7 8.4,14.7 C8.896875,14.7 9.3,15.1027588 9.3,15.6 C9.3,16.096875 8.896875,16.5 8.4,16.5 Z",
    id: "icon",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaming);
export default __webpack_public_path__ + "static/media/gaming.ff2c676af46f478e9507baf600f63009.svg";
export { ForwardRef as ReactComponent };